
import {
  FilmIcon,
  RepeatIcon,
  LoaderIcon,
  FileTextIcon,
  FileIcon,
} from "vue-feather-icons";
import VideoIcon from "@/components/ui/icon/VideoIcon.vue";
import GIFIcon from "@/components/ui/icon/GIFIcon.vue";
import OthersIcon from "@/components/ui/icon/OthersIcon.vue";
import ImageIcon from "@/components/ui/icon/ImageIcon.vue";
import ApiIcon from "@/components/ui/icon/ApiIcon.vue";
import CompressionApiIcon from "@/components/ui/icon/CompressionApiIcon.vue";

export default {
  name: "NavigationToolList",
  components: {
    FilmIcon,
    RepeatIcon,
    LoaderIcon,
    FileTextIcon,
    FileIcon,
    ImageIcon,
    VideoIcon,
    GIFIcon,
    OthersIcon,
    ApiIcon,
    CompressionApiIcon,
  },
  props: {
    tools: {
      required: true,
      default: [],
      type: Array,
    },
  },
  emits: ["linkClick"],
  methods: {
    closeModal() {
      setTimeout(() => {
        this.$store.commit("setActiveMenu", '');
      }, 500)
    },
    makeURL: (url) => {
      if (url.includes("apng-to-gif") || url.includes("gif-to-apng")) {
        return url.replace("/convert/", "/");
      }
      return url;
    },
  },
};
